import React, { useState } from 'react';

export const Toast = ({ message, onClose }) => (
    <div className="fixed bottom-4 right-4 bg-emerald-600 text-white px-4 py-2 rounded shadow-lg z-50">
        <div className="flex items-center justify-between">
            <span>{message}</span>
            <button onClick={onClose} className="ml-4 font-bold">×</button>
        </div>
    </div>
);

export const useToast = (duration = 3000) => {
    const [toastMessage, setToastMessage] = useState("");
    
    const showToast = (message) => {
        setToastMessage(message);
        setTimeout(() => setToastMessage(""), duration);
    };

    const hideToast = () => {
        setToastMessage("");
    };
    
    return { toastMessage, showToast, hideToast };
}; 